import { formatDateTime, DATE_FORMATS } from '@belong/common';
import { legacyParse } from 'forkedlibraries/date-fns-upgrade';
// Format returned by API
// Eg: 2018-12-01T00:00:00 "yyyy-MM-dd'T'HH:mm:ssxxx"

// Helper function to convert user input to api-readable
// date-time string.
// @param
//   'mm/dd/yyyy'
// @return
//   'yyyy-MM-ddTHH:MM:SS<Offset If Applicable>
//   Eg. 2018-10-18T10:00:00
export const parseDateTimeInputString = (userInputDate, formatProp) => {
  if (userInputDate) {
    const [mm, dd, yyyy] = userInputDate.split('/');
    const dateTime = legacyParse(`${yyyy}/${mm}/${dd}`);
    const format = formatProp || DATE_FORMATS.STRIPPED_ISO;

    return formatDateTime({ dateTime, format });
  }
};

export const parseMMYYDateToFirstDayOfMonth = (userInputDate) => {
  const [mm, yy] = userInputDate.split('/');

  return `20${yy}-${mm}-01`;
};

export const parseDateTimeInputStringMMDDYY = (userInputDate, formatProp) => {
  if (userInputDate) {
    const [mm, dd, yy] = userInputDate.split('/');

    if (mm && dd && yy) {
      const dateTime = legacyParse(`20${yy}/${mm}/${dd}`);
      const format = formatProp || DATE_FORMATS.STRIPPED_ISO;

      return formatDateTime({ dateTime, format });
    }

    const dateTime = legacyParse(userInputDate);

    if (!Number.isNaN(dateTime)) {
      const format = formatProp || DATE_FORMATS.STRIPPED_ISO;

      return formatDateTime({ dateTime, format });
    }
  }
};

// Helper function to convert server response into
// a JavaScript date-time object
// @param
//   'YYYY-MM-DDTHH:mm:ss'
// @return
//   Date object (similar to new Date())
export const converDateTimeServerResponseToDateTimeObject = (dateString) =>
  legacyParse(dateString);

// Helper function to only compare year, month and day
// for two date objects (ignores HH:MM:SS values)
// @param
//   dateTimeObjectOne: instanceOf(Date)
//   dateTimeObjectTwo: instanceOf(Date)
// @return
//   true // if equal
